import { render } from "./ExtratosEdit.vue?vue&type=template&id=a1a79ad6&scoped=true"
import script from "./ExtratosEdit.vue?vue&type=script&lang=js"
export * from "./ExtratosEdit.vue?vue&type=script&lang=js"

import "./ExtratosEdit.vue?vue&type=style&index=0&id=a1a79ad6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a79ad6"]])

export default __exports__